import { useState, useEffect } from 'react'
import { parse } from 'papaparse'
import { Toaster } from '@ui'

export interface IImportMapping {
  id: number
  siq: string | null
  csv: string
}

export default function useFileReader() {
  const [file, setFile] = useState<File | null>(null)
  const [fileContent, setFileContent] = useState<string>('')
  const [parsedContent, setParsedContent] = useState<any[]>([])

  useEffect(() => {
    if (file) {
      parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: ({ data }) => {
          setParsedContent(data)
        },
      })

      const reader = new FileReader()
      reader.addEventListener('load', (e) => setFileContent(e.target?.result as string))
      reader.addEventListener('error', () => {
        Toaster.fail({ message: 'Oops, something went wrong...' })
      })
      reader.readAsDataURL(file)
    }
  }, [file])

  return {
    file,
    setFile,
    fileContent,
    parsedContent,
  }
}
